import React from 'react';
import styled from 'styled-components';
import MuiTableCell from '@material-ui/core/TableCell';

const StyledTableCell = styled(MuiTableCell)`
  border-bottom: 1px solid ${props => props.theme.tableRow};
  padding-left: 8px;
  padding-right: 8px;
  box-sizing: border-box;
  &:first-of-type {
    padding-left: 0px;
  }
  /* Default: single-line headers; .header-wrap (per-column) allows multi-line titles. */
  &.MuiTableCell-head {
    white-space: nowrap;
    word-break: normal;
    overflow-wrap: normal;
    vertical-align: bottom;
  }
  &.MuiTableCell-head.header-wrap {
    white-space: normal;
    word-break: normal;
    overflow-wrap: normal;
    vertical-align: bottom;
    overflow: visible;
  }
  &.body {
    background-color: ${props => props.theme.cardBg};
    word-break: normal;
    overflow-wrap: break-word;
    vertical-align: top;
  }
`;

function TableCell(props) {
  const {className, children, body, ...rest} = props;

  return (
    <StyledTableCell className={(body ? 'body ' : '') + className} {...rest}>
      {children}
    </StyledTableCell>
  );
}

export default TableCell;
